// data.ts - Sample Data and Constants
import { Property, Area, User, Vehicle, Bin, Equipment, Role, Permission, PaymentFrequency, PaymentMethod } from './types';

export const sampleProperties: Property[] = [
  { 
    id: 1, roadNo: '68', plotNo: '1345/1', name: 'Srinivasa Raja', category: 'Residential', 
    monthlyRate: 200, paymentFrequency: 'monthly', dues: 400, penalty: 50,
    phone: '9876543210', address: 'Plot 1345/1, Road 68, Jubilee Hills',
    lastPayment: '2024-01-15', nextDue: '2024-04-15', areaId: 1
  },
  { 
    id: 2, roadNo: '68', plotNo: '1354', name: 'PETROL BUNK', category: 'Commercial', 
    monthlyRate: 500, paymentFrequency: 'quarterly', dues: 1500, penalty: 150,
    phone: '9876543211', address: 'Plot 1354, Road 68, Jubilee Hills',
    lastPayment: '2023-12-20', nextDue: '2024-06-20', areaId: 1
  },
  { 
    id: 3, roadNo: '68', plotNo: '1299D', name: 'Office Complex', category: 'Commercial', 
    monthlyRate: 300, paymentFrequency: 'yearly', dues: 3600, penalty: 360,
    phone: '9876543212', address: 'Plot 1299D, Road 68, Jubilee Hills',
    lastPayment: '2023-02-01', nextDue: '2024-02-01', areaId: 2
  }
];

export const sampleAreas: Area[] = [
  { id: 1, name: 'Jubilee Hills - Sector 1', code: 'JH-S1', propertyCount: 45, userCount: 3 },
  { id: 2, name: 'Jubilee Hills - Sector 2', code: 'JH-S2', propertyCount: 38, userCount: 2 },
  { id: 3, name: 'Banjara Hills - Zone A', code: 'BH-ZA', propertyCount: 52, userCount: 4 },
  { id: 4, name: 'Film Nagar - Block 1', code: 'FN-B1', propertyCount: 30, userCount: 2 }
];

export const sampleUsers: User[] = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    email: 'rajesh.kumar@waste.gov',
    phone: '9876543201',
    role: 'admin',
    status: 'active',
    assignedAreas: [],
    permissions: ['all'],
    lastLogin: '2024-04-15 10:30 AM',
    createdDate: '2023-01-15',
    avatar: '👨‍💼'
  },
  {
    id: 2,
    name: 'Priya Sharma',
    email: 'priya.sharma@waste.gov',
    phone: '9876543202',
    role: 'supervisor',
    status: 'active',
    assignedAreas: [1, 2],
    permissions: ['view_reports', 'manage_collectors', 'view_assets', 'manage_payments'],
    lastLogin: '2024-04-15 09:15 AM',
    createdDate: '2023-03-20',
    avatar: '👩‍💼'
  },
  {
    id: 3,
    name: 'Mohammed Ali',
    email: 'mohammed.ali@waste.gov',
    phone: '9876543203',
    role: 'collector',
    status: 'active',
    assignedAreas: [1],
    permissions: ['collect_payment', 'view_properties', 'generate_receipt'],
    lastLogin: '2024-04-15 08:45 AM',
    createdDate: '2023-06-10',
    avatar: '👨'
  },
  {
    id: 4,
    name: 'Sunita Reddy',
    email: 'sunita.reddy@waste.gov',
    phone: '9876543204',
    role: 'collector',
    status: 'active',
    assignedAreas: [2],
    permissions: ['collect_payment', 'view_properties', 'generate_receipt'],
    lastLogin: '2024-04-14 06:30 PM',
    createdDate: '2023-07-05',
    avatar: '👩'
  },
  {
    id: 5,
    name: 'Ravi Verma',
    email: 'ravi.verma@waste.gov',
    phone: '9876543205',
    role: 'driver',
    status: 'inactive',
    assignedAreas: [3],
    permissions: ['view_route', 'update_status'],
    lastLogin: '2024-04-10 07:00 AM',
    createdDate: '2023-08-15',
    avatar: '👷'
  }
];

export const sampleVehicles: Vehicle[] = [
  {
    id: 1,
    vehicleNo: 'TS09GC2451',
    type: 'Compactor',
    capacity: '5 Tons',
    driver: 'Rajesh Kumar',
    driverPhone: '9876543201',
    status: 'active',
    fuelLevel: 75,
    lastMaintenance: '2024-03-01',
    nextMaintenance: '2024-06-01',
    currentLocation: 'Road 68, Sector 2',
    routeAssigned: 'Route A - Jubilee Hills',
    kmReading: 45230,
    condition: 'good'
  },
  {
    id: 2,
    vehicleNo: 'TS09GC2452',
    type: 'Tipper',
    capacity: '3 Tons',
    driver: 'Suresh Yadav',
    driverPhone: '9876543202',
    status: 'maintenance',
    fuelLevel: 40,
    lastMaintenance: '2024-02-15',
    nextMaintenance: '2024-05-15',
    currentLocation: 'Depot',
    routeAssigned: 'Route B - Banjara Hills',
    kmReading: 67890,
    condition: 'maintenance'
  }
];

export const sampleBins: Bin[] = [
  {
    id: 1,
    binId: 'BIN001',
    type: 'Community Bin',
    capacity: '1100L',
    location: 'Road 68, Near Park',
    status: 'full',
    fillLevel: 95,
    lastEmptied: '2024-04-13',
    condition: 'good',
    assignedArea: 'Sector 2A'
  },
  {
    id: 2,
    binId: 'BIN002',
    type: 'Street Bin',
    capacity: '240L',
    location: 'Road 68, Main Junction',
    status: 'partial',
    fillLevel: 45,
    lastEmptied: '2024-04-14',
    condition: 'good',
    assignedArea: 'Sector 2B'
  }
];

export const sampleEquipment: Equipment[] = [
  {
    id: 1,
    name: 'Pressure Washer',
    code: 'EQ001',
    status: 'available',
    assignedTo: 'Team A',
    lastService: '2024-03-01',
    condition: 'good'
  },
  {
    id: 2,
    name: 'Leaf Blower',
    code: 'EQ002',
    status: 'in-use',
    assignedTo: 'Team B',
    lastService: '2024-02-15',
    condition: 'excellent'
  }
];

export const roles: Role[] = [
  { 
    id: 'admin', 
    name: 'Administrator', 
    icon: '👨‍💼',
    color: 'bg-purple-50 text-purple-700 border-purple-200',
    permissions: ['all']
  },
  { 
    id: 'supervisor', 
    name: 'Supervisor', 
    icon: '👨‍🏫',
    color: 'bg-blue-50 text-blue-700 border-blue-200',
    permissions: ['view_reports', 'manage_collectors', 'view_assets', 'manage_payments']
  },
  { 
    id: 'collector', 
    name: 'Fee Collector', 
    icon: '💰',
    color: 'bg-green-50 text-green-700 border-green-200',
    permissions: ['collect_payment', 'view_properties', 'generate_receipt']
  },
  { 
    id: 'driver', 
    name: 'Driver', 
    icon: '🚚',
    color: 'bg-yellow-50 text-yellow-700 border-yellow-200',
    permissions: ['view_route', 'update_status']
  },
  { 
    id: 'cleaner', 
    name: 'Cleaner', 
    icon: '🧹',
    color: 'bg-gray-50 text-gray-700 border-gray-200',
    permissions: ['view_schedule', 'update_task']
  }
];

export const allPermissions: Permission[] = [
  { id: 'all', name: 'All Permissions', category: 'System' },
  { id: 'collect_payment', name: 'Collect Payments', category: 'Finance' },
  { id: 'view_properties', name: 'View Properties', category: 'Properties' },
  { id: 'manage_properties', name: 'Manage Properties', category: 'Properties' },
  { id: 'generate_receipt', name: 'Generate Receipts', category: 'Finance' },
  { id: 'view_reports', name: 'View Reports', category: 'Reports' },
  { id: 'manage_collectors', name: 'Manage Collectors', category: 'Users' },
  { id: 'view_assets', name: 'View Assets', category: 'Assets' },
  { id: 'manage_assets', name: 'Manage Assets', category: 'Assets' },
  { id: 'manage_payments', name: 'Manage Payments', category: 'Finance' },
  { id: 'view_route', name: 'View Routes', category: 'Operations' },
  { id: 'update_status', name: 'Update Status', category: 'Operations' },
  { id: 'view_schedule', name: 'View Schedule', category: 'Operations' },
  { id: 'update_task', name: 'Update Tasks', category: 'Operations' },
  { id: 'manage_users', name: 'Manage Users', category: 'Users' },
  { id: 'manage_areas', name: 'Manage Areas', category: 'System' }
];

export const paymentFrequencies: PaymentFrequency[] = [
  { id: 'monthly', name: 'Monthly', multiplier: 1, icon: '📅' },
  { id: 'quarterly', name: 'Quarterly', multiplier: 3, icon: '📊', discount: 5 },
  { id: 'yearly', name: 'Yearly', multiplier: 12, icon: '🗓️', discount: 10 }
];

export const paymentMethods: PaymentMethod[] = [
  { id: 'cash', name: 'Cash', icon: '💵' },
  { id: 'card', name: 'Card', icon: '💳' },
  { id: 'upi', name: 'UPI', icon: '📱' },
  { id: 'bank', name: 'Bank Transfer', icon: '🏦' }
];